"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _baseMonitor = _interopRequireDefault(require("./baseMonitor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FeMonitor = /*#__PURE__*/function (_BaseMonitor) {
  _inherits(FeMonitor, _BaseMonitor);

  var _super = _createSuper(FeMonitor);

  function FeMonitor() {
    var _this;

    _classCallCheck(this, FeMonitor);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setConfig", function () {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        Object.assign(_this.config, config); // 方便测试修改minReportCount和minReportDelay

        Object.assign(_this.baseConfig, config);
      } catch (e) {
        console.log('FeMonitor:', e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "definePublicReport", function () {
      if (_this.getEnv() === 'wx') {
        wx._feMonitor = {
          reportApi: _this.reportApi,
          reportJsError: _this.reportJsError,
          reportEvent: _this.reportEvent,
          setPage: _this.setPage
        };
      } else if (_this.getEnv() === 'web') {
        window._feMonitor = {
          reportApi: _this.reportApi,
          reportJsError: _this.reportJsError,
          reportEvent: _this.reportEvent,
          setPage: _this.setPage
        };
      } else if (_this.getEnv() === 'weex') {
        weex._feMonitor = {
          reportApi: _this.reportApi,
          reportJsError: _this.reportJsError,
          reportEvent: _this.reportEvent,
          setPage: _this.setPage
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFetch", function (options) {
      if (_this.config.auto) {
        var url = options.url,
            success = options.success,
            duration = options.duration,
            code = options.code,
            message = options.message;

        _this.reportApi({
          apiName: url,
          success: success,
          duration: duration,
          code: code,
          message: message
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onJsError", function (message, attr) {
      if (_this.config.auto) {
        _this.reportJsError({
          message: message,
          attr: _objectSpread({
            info: message
          }, attr)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPageUnload", function () {
      clearTimeout(_this.heart);

      _this.upload(_this.getReportList(), true);
    });

    _defineProperty(_assertThisInitialized(_this), "canReport", function () {
      var _this$baseConfig = _this.baseConfig,
          minReportCount = _this$baseConfig.minReportCount,
          minReportDelay = _this$baseConfig.minReportDelay;
      var now = +new Date();

      if (_this.eventStack.length >= minReportCount || !_this.lastReportTime || now - _this.lastReportTime >= minReportDelay) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getReportList", function () {
      var reportList = [].concat(_this.eventStack);
      _this.eventStack = [];
      _this.lastReportTime = +new Date();
      return reportList;
    });

    _defineProperty(_assertThisInitialized(_this), "reportApi", function (_ref) {
      var apiName = _ref.apiName,
          success = _ref.success,
          duration = _ref.duration,
          code = _ref.code,
          _ref$message = _ref.message,
          message = _ref$message === void 0 ? '' : _ref$message,
          _ref$attr = _ref.attr,
          attr = _ref$attr === void 0 ? {} : _ref$attr;

      if (!apiName || typeof success !== 'boolean') {
        console.error('feMonitor: reportApi方法的apiName和success为必填项');
        return;
      }

      if (success) {
        return;
      }

      if (/^http:\/\/127.0.0.1/.test(apiName)) {
        return;
      }

      _this.report({
        eventId: "".concat(_this.config.moduleName || "".concat(_this.config.line, "-").concat(_this.config.project), "-").concat(success ? 'api-event' : 'api-error'),
        apiName: apiName,
        success: success,
        duration: duration,
        code: code,
        message: message,
        attr: _objectSpread(_objectSpread({}, attr), {}, {
          apiName: apiName,
          success: success,
          duration: duration,
          code: code,
          message: message
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reportJsError", function (_ref2) {
      var message = _ref2.message,
          _ref2$attr = _ref2.attr,
          attr = _ref2$attr === void 0 ? {} : _ref2$attr;

      if (!message) {
        console.error('feMonitor: reportJsError 方法的message为必填项');
      }

      _this.report({
        eventId: "".concat(_this.config.moduleName || "".concat(_this.config.line, "-").concat(_this.config.project), "-js-error"),
        success: false,
        info: message,
        attr: attr
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reportEvent", function (options) {
      if (!options.eventId) {
        console.error('feMonitor: 自定义事件的 eventId不能为空'); // throw new Error('feMonitor: eventId不能为空')

        return;
      }

      _this.report(options);
    });

    _defineProperty(_assertThisInitialized(_this), "report", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var _this$config = _this.config,
            moduleName = _this$config.moduleName,
            appid = _this$config.appid,
            line = _this$config.line,
            project = _this$config.project;

        if (!moduleName && (!line || !project)) {
          console.error('feMonitor: 缺少line或project,请使用setConfig方法设置');
          return;
        }

        var attr = options.attr;

        _this.getDefaultAttr().then(function (defaultAttr) {
          try {
            var ev = Object.assign({
              appid: appid,
              line: line,
              project: project,
              moduleName: moduleName || "".concat(line, "-").concat(project),
              page: _this.getPage(),
              time: Date.now(),
              defaultAttr: JSON.stringify(defaultAttr) // 默认参数，设备信息等

            }, options, {
              attr: _objectSpread(_objectSpread({}, attr), {}, {
                line: line,
                project: project,
                moduleName: moduleName,
                appid: appid,
                page: _this.getPage(),
                time: Date.now()
              })
            });

            _this.eventStack.push(ev);

            _this.checkReport();
          } catch (e) {
            console.error('feMonitor:', e);
          }
        });
      } catch (e) {
        console.error('feMonitor:', e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setPage", function (page) {
      _this.config.page = page;
    });

    _defineProperty(_assertThisInitialized(_this), "getPage", function () {
      if (_this.config.page) {
        return _this.config.page;
      }

      if (_this.getEnv() === 'web') {
        return location.href;
      }

      if (_this.getEnv() === 'wx') {
        var pages = getCurrentPages();

        if (pages && pages.length) {
          return pages[pages.length - 1].route;
        }
      } else if (_this.getEnv() === 'weex') {
        return weex.config.bundleUrl;
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "getDefaultAttr", function () {
      return new Promise(function (resolve, reject) {
        if (_this.getEnv() === 'web') {
          var nv = navigator || {};
          resolve({
            ua: nv.userAgent,
            appName: nv.appName,
            appVersion: nv.appVersion,
            minReportDelay: _this.baseConfig.minReportDelay,
            minReportCount: _this.baseConfig.minReportCount,
            sendBeacon: !!window.navigator.sendBeacon
          });
        } else if (_this.getEnv() === 'wx') {
          wx.getNetworkType({
            complete: function complete(res) {
              resolve(_objectSpread(_objectSpread({}, wx.getSystemInfoSync()), {}, {
                networkType: res && res.networkType || '',
                minReportDelay: _this.baseConfig.minReportDelay,
                minReportCount: _this.baseConfig.minReportCount
              }));
            }
          });
        } else if (_this.getEnv() === 'weex') {
          resolve(weex.config.env);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkReport", function () {
      clearTimeout(_this.heart);

      if (_this.canReport()) {
        _this.upload(_this.getReportList());
      }

      _this.heart = setTimeout(function () {
        _this.checkReport();
      }, _this.baseConfig.minReportDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "upload", function (reportList, unLoad) {
      try {
        if (reportList.length) {
          var reportUrl = _this.baseConfig.reportUrl;

          if (_this.getEnv() === 'web') {
            if (window.navigator && window.navigator.sendBeacon) {
              window.navigator.sendBeacon(reportUrl, JSON.stringify(reportList));
            } else if (unLoad) {
              _this.syncRequest(reportUrl, JSON.stringify(reportList));
            } else {
              _this.originFetch && _this.originFetch.call(window, reportUrl, {
                mode: 'cors',
                method: 'post',
                headers: {
                  'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(reportList)
              });
            }
          } else if (_this.getEnv() === 'wx') {
            _this.originRequest && _this.originRequest({
              url: reportUrl,
              method: 'post',
              data: JSON.stringify(reportList)
            });
          } else if (_this.getEnv() === 'weex') {
            var stream = weex.requireModule('stream');
            stream.fetch({
              url: reportUrl,
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              method: 'post',
              body: JSON.stringify(reportList)
            });
          }
        }
      } catch (e) {
        console.error('feMonitor:', e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "autoJsError", function () {
      return !!wx.onError;
    });

    _this.eventStack = []; // 上报事件堆栈
    // this.field = ['line', 'project', 'page', 'eventId', 'success', 'eventType', 'apiName', 'code', 'duration', 'message', 'attr', 'time']

    _this.baseConfig = {
      reportUrl: 'https://gw.am.xiaojukeji.com/fe-monitor/event',
      minReportCount: 5,
      // 最小上报数量
      minReportDelay: 5000 // 最小上报间隔

    };
    _this.config = {
      appid: '',
      // appid
      moduleName: '',
      // 模块名
      line: '',
      // 业务线
      project: '',
      // 项目
      auto: true // 开启自动上报

    }; // 设置对外开发的上报接口
    // 分 wx、web、weex

    _this.definePublicReport();

    return _this;
  } // 使用的时候会先调用 setConfig 方法

  /**
   * import feMonitor from '@didi/fe-monitor';
   * feMonitor.setConfig({
   *     appid: '10005', // 业务线
   *     moduleName: 'boss-energy', // 项目
   *    auto: true, // 开启自动上报,默认为true
   * });
  */


  return FeMonitor;
}(_baseMonitor.default);

var monitor = new FeMonitor();
var _default = monitor;
exports.default = _default;